import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Awards from "./components/Awards";
import Team from "./components/Team";
import Contact from "./components/Contact";
import Sponsers from "./components/Sponsers";
import Footer from "./components/Footer"
import "./App.css";

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Sponsers />
      <Awards />
      <Team />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
